import React, { ChangeEvent, ForwardedRef, forwardRef, PropsWithChildren } from 'react';
import { CField, CFieldAutoCapitalize, CFieldAutoCorrect, CFieldEnterKeyHint, CFieldInputMode, CFieldProps } from '@/src/components/c-field/CField';

export enum CFieldTextType {
  Text = 'text',
  Email = 'email',
  Url = 'url',
  Tel = 'tel',
  Search = 'search',
}

export interface CFieldTextProps extends CFieldProps {
  type?: CFieldTextType;
  inputMode?: CFieldInputMode;
  enterKeyHint?: CFieldEnterKeyHint;
  autoCapitalize?: CFieldAutoCapitalize;
  autoCorrect?: CFieldAutoCorrect;
}

export const CFieldText = forwardRef(function CTextField(props: PropsWithChildren<CFieldTextProps>, ref: ForwardedRef<HTMLInputElement>): React.JSX.Element {
  return (
    <CField
      id={props.id}
      value={props.value}
      label={props.label}
      class={props.class}
      disabled={props.disabled}
      required={props.required}
      validations={props.validations}
      testSelector={props.testSelector}
      placeholder={props.placeholder}
      hideMessageContainer={props.hideMessageContainer}
      fullWidth={props.fullWidth}
      onBlur={props.onBlur}
      onChange={props.onChange}
      onFocus={props.onFocus}
      onKeyUp={props.onKeyUp}
      onKeyDown={props.onKeyDown}
      formId={props.formId}
      security={props.security}
    >
      {({ id, value, setValue}) => (
        <input
          ref={ref}
          name={props.name}
          pattern={props.pattern}
          required={props.required}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          onKeyUp={props.onKeyUp}
          onKeyDown={props.onKeyDown}
          disabled={props.disabled}
          aria-disabled={props.disabled}
          autoComplete={props.autoComplete}
          className="c-field__input"
          inputMode={props.inputMode}
          enterKeyHint={props.enterKeyHint}
          autoCapitalize={props.autoCapitalize}
          autoCorrect={props.autoCorrect}
          id={id}
          type={props.type ?? 'text'}
          value={value}
          placeholder={props.placeholder}
          onChange={(event: ChangeEvent) => setValue(event, (event.currentTarget as HTMLInputElement).value)}
        />
      )}
    </CField>
  );
})